import React, { useEffect, useState } from 'react'
import '../styles/Target.css';

function TargetGroß(props) {

    var TargetText = props.TargetText;
    var TargetFont = props.TargetFont;
    var TargetType = props.TargetType;
    var theTheme = props.Theme;
    var TargetVisibility = props.Visibility;
    const [Font, setFont] = useState('0');
    const [Type, setType] = useState('0');
    const [WorldTheme, setWorldTheme] = useState('Default');
    const [TypeSelection, setTypeSelection] = useState('TargetType1');
    const [TargetFrame, setTargetFrame] = useState('TargetFrameSD');
    const [UpperTitel, setUpperTitel] = useState('UpperTitelDefault');
    const [LowerTitel, setLowerTitel] = useState('LowerTitelDefault');
    const [Tape, setTape] = useState('TapeDefault');
    const [WantedWindow, setWantedWindow] = useState('WantedWindowDefault');
    const [TargetWrapper, setTargetWrapper] = useState('TargetWrapperDefault');
    const [Rotator, setRotator] = useState('RotatorDefault');

    useEffect(()=> {
        if(theTheme == "SecretDucks"){
            setWorldTheme('SecretDucks');
            setTargetWrapper('TargetWrapperSD');
            setTargetFrame('TargetFrameSD')
            setUpperTitel('UpperTitelSD');
            setLowerTitel('LowerTitelSD');
            setTape('TapeSD');
            setWantedWindow('WantedWindowSD');
            setRotator('RotatorSD')
            
        }
        if(theTheme == "Default"){
            setWorldTheme('Default');
            setTargetWrapper('TargetWrapperDefault');
            setTargetFrame('TargetFrameDefault')
            setUpperTitel('UpperTitelDefault');
            setUpperTitel('LowerTitelDefault');
            setTape('TapeDefault');
            setWantedWindow('WantedWindowDefault');
        }
    })
    
    useEffect(() => {
        if(TargetType =="1"){setTypeSelection('TargetType1')}
        if(TargetType =="2"){setTypeSelection('TargetType2')}
        if(TargetType =="3"){
            setTypeSelection('TargetType3');
            if(TargetText=="img001")
            {
                setTypeSelection('TargetType3 Maus');
            }
            if(TargetText=="Nase")
            {
                setTypeSelection('TargetType3 Nase');
            }
            if(TargetText=="Boden")
            {
                setTypeSelection('TargetType3 Boden');
            }
            if(TargetText=="denke")
            {
                setTypeSelection('TargetType3 Denken');
            }
            if(TargetText=="findet")
            {
                setTypeSelection('TargetType3 Finden');
            }
            if(TargetText=="Entenerpel")
            {
                setTypeSelection('TargetType3 Entenerpel');
            }
            if(TargetText=="Feigenkerne")
            {
                setTypeSelection('TargetType3 Feigenkerne');
            }
            if(TargetText=="verbogen")
            {
                setTypeSelection('TargetType3 Verbogen');
            }
            if(TargetText=="geliket")
            {
                setTypeSelection('TargetType3 Gelikt');
            }
            if(TargetText=="Besen")
            {
                setTypeSelection('TargetType3 Besen');
            }
            if(TargetText=="Farbe")
            {
                setTypeSelection('TargetType3 Farbe');
            }
            if(TargetText=="fege")
            {
                setTypeSelection('TargetType3 fege');
            }
            if(TargetText=="badet")
            {
                setTypeSelection('TargetType3 badet');
            }
            if(TargetText=="Pudelbeine")
            {
                setTypeSelection('TargetType3 Pudelbeine');
            }
            if(TargetText=="Notenhefte")
            {
                setTypeSelection('TargetType3 Notenhefte');
            }
            if(TargetText=="gelogen")
            {
                setTypeSelection('TargetType3 gelogen');
            }
            if(TargetText=="downloaden")
            {
                setTypeSelection('TargetType3 downloaden');
            }
        }

    })


    

  return (
      <div className={TargetWrapper}>
            <div className={TargetFrame}>
                <div className={UpperTitel}>! ! ! </div>
                <div className={Rotator}></div>
                <div className={WantedWindow}>
                    <div className='TargetFeld'>
                        <div className={TypeSelection}>{TargetText}</div>
                    </div>

                </div>
                <div className={LowerTitel}>! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !</div>
            </div>
            <div className={Tape}></div>
      </div>
     
         
    
  )
}

export default TargetGroß